<template>
  <div class="onboarding-signup-step-address">
    <VeeForm @submit="onSubmit">
      <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
        <QPage padding>
          <h2 class="step-title">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.MAIN.ADDRESS.@TITLE")) }}
          </h2>

          <AddressForm v-model:address="address" v-model:city="city" v-model:postal-code="postalCode" :i-model="ISignup" />

          <ExtraTipbox>
            <span>{{ $t("ETAB.PAGES.SIGNUP.STEPS.MAIN.ADDRESS.@NOTICE") }}</span>
          </ExtraTipbox>
        </QPage>
      </transition>

      <QFooter>
        <div>
          <QBtn color="secondary" type="submit" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@NEXT')" no-caps />
        </div>
      </QFooter>
    </VeeForm>
  </div>
</template>

<script setup>
  import { Form as VeeForm } from "vee-validate";
  import { ISignup } from "@core/models";
  import { ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { FIREBASE_EVENTS } from "@core/constants";
  import { onMounted, ref } from "vue";
  import { useSignup } from "@etab/composables";
  import { useTransition } from "@core/composables";
  import AddressForm from "@etab/components/onboarding/signup/AddressForm.component.vue";

  const { transition } = useTransition();
  const { $_nextStep } = useSignup();
  const signupStore = useSignupStore();

  const address = ref("");
  const city = ref("");
  const postalCode = ref(null);

  const onSubmit = async function () {
    const data = {
      [ISignup.address]: address.value,
      [ISignup.city]: city.value,
      [ISignup.postalCode]: postalCode.value,
    };

    signupStore[ACTION_SIGNUP_UPDATE](data);
    TrackingManager.addEvent({
      event: FIREBASE_EVENTS.FUNNEL,
      step: "step5_address",
    });
    $_nextStep();
  };

  onMounted(() => {
    address.value = signupStore[GETTER_SIGNUP_GET][ISignup.address] || "";
    city.value = signupStore[GETTER_SIGNUP_GET][ISignup.city] || "";
    postalCode.value = signupStore[GETTER_SIGNUP_GET][ISignup.postalCode] || null;
  });
</script>

<style lang="scss">
  .onboarding-signup-step-address {
    .extra-tipbox {
      margin-top: 50px;
    }
  }
</style>
